export const COLOR_THEME = {
  light: {
    page: '#f5f5f5',
    card: '#fff',
    shadow: 'rgba(50, 50, 50, 0.3)',
    border_bottom: 'rgba(70, 70, 70, 0.5)',
    text_submit: '#fff',
    text_title: '#222',
    text_primary: '#444',
    text_primary_highlight: '#111',
    text_primary_edit: '#777',
    btn_grey: '#f3f3f3',
    func: '#32539A',
    func_hover: '#28427B',
    func_transparent: '#28427B33',
    checkbox: '#cecece',
    checked: 'rgba(120, 120, 120, 0.1)'
  },
  dark: {
    page: '#121212',
    card: '#1f1f1f',
    shadow: 'rgba(0, 0, 0, 0.3)',
    border_bottom: 'rgba(180, 180, 180, 0.5)',
    text_submit: '#fff',
    text_title: '#fff',
    text_primary: '#ddd',
    text_primary_highlight: '#fff',
    text_primary_edit: '#ccc',
    btn_grey: '#2d2d2d',
    func: '#c70e62',
    func_hover: '#db1a73',
    func_transparent: '#c70e6233',
    checkbox: '#9a9a9a',
    checked: 'rgba(120, 120, 120, 0.1)'
  }
}
